module.exports = __webpack_public_path__ + "img/arrows.ca86b553.png";